import React from 'react';
import { colors, fonts } from '../tokens';

/**
 * StatCard – einzelne Kennzahl im StatsGrid (z. B. "100+ Realisierte Projekte").
 * Layout-Abstände kommen vom Parent-Grid; Card definiert nur eigenes Innenpadding.
 */
export const StatCard = ({ value, label, sub, withRightBorder = true }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '0 8px',
      height: '100%',
      borderRight: withRightBorder ? `1px solid ${colors.border}` : 'none',
    }}
  >
    <p style={{ fontFamily: fonts.display, fontSize: '28px', fontWeight: 800, color: colors.navy, letterSpacing: '-0.03em', margin: '0 0 2px' }}>{value}</p>
    <p style={{ fontFamily: fonts.body, fontSize: '8.5px', fontWeight: 700, color: colors.slateDark, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '1px' }}>{label}</p>
    <p style={{ fontFamily: fonts.body, fontSize: '8px', color: colors.slateLight, margin: 0 }}>{sub}</p>
  </div>
);
